module.exports = __webpack_public_path__ + "static/img/pro6_tab4.f790e30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro6_tab4.jpg
// module id = neAW
// module chunks = 171